// 3rd party
import * as ReactDOM from "react-dom";
import * as React from "react";
import * as redux from "redux";
import { Provider } from "react-redux";
import * as reduxLoop from "redux-loop";
import { ThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import "@fontsource/exo";

// Views
import { ConnectedView, reducer, init, State } from "@src/presentation/root";

// Styles
import { muiTheme } from "./presentation/styles/material-theme";

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const composeEnhancers =
	// eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	(window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux.compose;
const store: redux.Store<State> = redux.createStore(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	reducer as any,
	init,
	// eslint-disable-next-line @typescript-eslint/no-unsafe-call
	composeEnhancers(reduxLoop.install())
);

function App(): JSX.Element {
	return (
		<Provider store={store}>
			<>
				<ThemeProvider theme={muiTheme}>
					<CssBaseline />
					<ConnectedView />
				</ThemeProvider>
			</>
		</Provider>
	);
}

ReactDOM.render(<App />, document.getElementById("app"));
